export default "__VITE_ASSET__CGEfQIe8__"